// extracted by mini-css-extract-plugin
export default {"box":"modal_box__-52W6","alt":"modal_alt__tZaJE","box-content":"modal_box-content__wE3CW"};